import {
  CHAN_DEVICE_BULK_EDIT,
  CHAN_DEVICE_BULK_REGISTER,
  CHAN_GENERIC_TASK,
} from "constant/protobuf";
import { eventChannel } from "redux-saga";
import { put, takeEvery } from "redux-saga/effects";
import { socket } from "websocket";

import { bulkDeviceHandler, genericTaskHandler } from "./handlers";

/*
 * Attach channel specific task handlers here.
 */
function taskHandlerEmitter(emitter) {
  const boundBulkDeviceHandlers = bulkDeviceHandler.bind(null, emitter);
  const boundGenericTaskHandler = genericTaskHandler.bind(null, emitter);

  socket.on(CHAN_DEVICE_BULK_EDIT, boundBulkDeviceHandlers);
  socket.on(CHAN_DEVICE_BULK_REGISTER, boundBulkDeviceHandlers);
  socket.on(CHAN_GENERIC_TASK, boundGenericTaskHandler);

  return () => {
    // Unsubscribe function
    socket.off(CHAN_DEVICE_BULK_EDIT, boundBulkDeviceHandlers);
    socket.off(CHAN_DEVICE_BULK_REGISTER, boundBulkDeviceHandlers);
    socket.off(CHAN_GENERIC_TASK, boundGenericTaskHandler);
  };
}

/**
 * Subscribe to task publications from API.
 *
 * @yield {IterableIterator<*>}
 */
function* tasksSaga() {
  const channel = yield eventChannel(taskHandlerEmitter);

  yield takeEvery(channel, put);
}

export { taskHandlerEmitter, tasksSaga };
